import { CustomersSay } from "./CustomersSay";

export { CustomersSay };
